import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { endpointUploadConversion, urlConversion } from '../services/Endpoints';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCloudUploadAlt, faFileAlt, faTrashAlt, faSync } from '@fortawesome/free-solid-svg-icons';

const FileUploader = ({
  account,
  ink_id,
  onSuccess,
  accept = ".epub",
  uploadUrl = `${urlConversion}${endpointUploadConversion}`,
  label = "Subir archivo",
  fileTypeLabel = "archivo",
  helpText = "o haz clic para buscar en tu equipo"
}) => {
  const [selectedFile, setSelectedFile] = useState(null);
  const [dragging, setDragging] = useState(false);
  const navigate = useNavigate();
  const [uploading, setUploading] = useState(false);
  const [labelButton, setLabelButton] = useState(label);

  const validateFile = (file) => {
    if (!file) return false;
    const extensions = accept.split(',').map(ext => ext.trim().toLowerCase());
    const fileName = file.name.toLowerCase();
    return extensions.some(ext => fileName.endsWith(ext));
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    setDragging(true);
  };

  const handleDragEnter = (e) => {
    e.preventDefault();
    setDragging(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    setDragging(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setDragging(false);
    const file = e.dataTransfer.files[0];
    if (validateFile(file)) {
      setSelectedFile(file);
    } else {
      alert(`Solo se permiten archivos: ${accept}`);
    }
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (validateFile(file)) {
      setSelectedFile(file);
    } else {
      alert(`Solo se permiten archivos: ${accept}`);
    }
  };

  const handleUpload = async () => {
    if (selectedFile) {
      const formData = new FormData();
      formData.append('file', selectedFile);
      formData.append('account', account);
      formData.append('ink_id', ink_id);

      setUploading(true);
      setLabelButton('Cargando...');
      try {
        const response = await fetch(uploadUrl, {
          method: 'POST',
          body: formData
        });

        const res = await response.json();
        if (res && res.status == 'success') {
          alert('Carga realizada correctamente.');
          if (onSuccess) {
            onSuccess();
          } else {
            navigate('/conversions');
          }
        } else {
          alert('Error al realizar la carga.');
        }
      } catch (error) {
        alert('Error de conexión al servidor.');
      }
      setUploading(false);
      setLabelButton(label);

    } else {
      alert(`Por favor, selecciona un ${fileTypeLabel}`);
    }
  };

  const handleDelete = () => {
    setSelectedFile(null);
  };

  return (
    <div className="file-uploader-container">
      <label
        onDragOver={handleDragOver}
        onDragEnter={handleDragEnter}
        onDragLeave={handleDragLeave}
        onDrop={handleDrop}
        htmlFor="fileInput"
        className={`dropzone d-flex flex-column align-items-center justify-content-center p-5 rounded-3 mb-4 transition-all ${dragging ? 'bg-primary bg-opacity-10 border-primary' : 'bg-dark border-secondary'}`}
        style={{
          border: '2px dashed',
          cursor: 'pointer',
          minHeight: '200px'
        }}
      >
        <FontAwesomeIcon icon={faCloudUploadAlt} size="3x" className={`mb-3 ${dragging ? 'text-primary' : 'text-secondary'}`} />
        <p className="mb-2 text-center text-light">
          {selectedFile ? '¡Archivo seleccionado!' : `Arrastra y suelta el ${fileTypeLabel} aquí`}
        </p>
        <p className="small text-secondary mb-0">{helpText}</p>

        <input
          type="file"
          id="fileInput"
          onChange={handleFileChange}
          style={{ display: 'none' }}
          accept={accept}
        />
      </label>

      {selectedFile && (
        <div className="mb-4 p-3 bg-dark rounded border border-primary border-opacity-25 d-flex align-items-center justify-content-between shadow-sm">
          <div className="d-flex align-items-center overflow-hidden">
            <FontAwesomeIcon icon={faFileAlt} className="text-primary me-3 flex-shrink-0" />
            <div className="overflow-hidden">
              <p className="fw-bold text-white mb-0 text-truncate">{selectedFile.name}</p>
              <p className="small text-secondary mb-0">{(selectedFile.size / (1024 * 1024)).toFixed(2)} MB</p>
            </div>
          </div>
          <button
            type="button"
            onClick={handleDelete}
            className="btn btn-outline-danger btn-sm rounded-circle ms-3"
            title="Eliminar"
            style={{ width: '32px', height: '32px', padding: '0' }}
          >
            <FontAwesomeIcon icon={faTrashAlt} />
          </button>
        </div>
      )}

      <div className='d-flex justify-content-center'>
        <button
          onClick={handleUpload}
          disabled={uploading || !selectedFile}
          className={`btn btn-primary px-5 py-2 fw-bold text-uppercase shadow-sm ${uploading ? 'opacity-75' : ''}`}
          style={{ minWidth: '200px' }}
        >
          {uploading ? (
            <>
              <FontAwesomeIcon icon={faSync} spin className="me-2" />
              Cargando...
            </>
          ) : labelButton}
        </button>
      </div>
    </div>
  );
};

export default FileUploader;
